import * as jsxRuntime from "/var/www/www-root/data/www/zic.pro-new.com/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment